import { AlarmsPortfolioGQL, AlarmsTurbineGQL, AlarmsParkGQL, AlarmsPortfolioCustomGQL, AlarmSortInput, AlarmsPortfolioReportGQL, AlarmsParkReportGQL, AlarmsTurbineReportGQL } from '../../graphql';
import { Injectable } from '@angular/core';
import {Observable, combineLatest, BehaviorSubject} from 'rxjs';
import { Alarms } from 'app/models/monitor/alarms.model';
import { map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Sort } from 'app/shared/services-api-v2/graphql';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class NewAlarmsService {

  constructor(
    private alarmsPortfolioGQL: AlarmsPortfolioGQL,
    private alarmsParkGQL: AlarmsParkGQL,
    private alarmsTurbineGQL: AlarmsTurbineGQL,
    private alarmsPortfolioReportGQL: AlarmsPortfolioReportGQL,
    private alarmsParkReportGQL: AlarmsParkReportGQL,
    private alarmsTurbineReportGQL: AlarmsTurbineReportGQL,
    private alarmsPortfolioCustomGQL: AlarmsPortfolioCustomGQL
  ) { }

  public getAlarmsPortfolioCustom(showAllObservable: Observable<boolean>, navigationDetails: NavigationDetails): Observable<Alarms> {
    return showAllObservable.pipe(
      distinctUntilChanged(),
      switchMap((showAll) => {
            const sort: AlarmSortInput = {createTS: Sort.Desc};
            const parameters = showAll ? { portfolioId: navigationDetails.selectedPortfolioId, hours: 24, sort, parkIds: navigationDetails.selectedParksIds} :
                { portfolioId: navigationDetails.selectedPortfolioId, showAll: !showAll, sort, parkIds: navigationDetails.selectedParksIds};
            return this.alarmsPortfolioCustomGQL.subscribe({
              variables: parameters
            }).pipe(
              map(result => {
                return Alarms.mapPortfolio(result.data.portfolios[0]); })
              );
        }
      )
    );
  }

  public getAlarmsPortfolio(showAllObservable: Observable<boolean>): Observable<Alarms> {
    return showAllObservable.pipe(
      distinctUntilChanged(),
      switchMap((showAll: boolean) =>
      this.alarmsPortfolioGQL.subscribe({
        variables: {
        showAll: !showAll}
      }).pipe(
        map(result => Alarms.mapPortfolio(result.data.portfolios[0]))
        )
      )
    );
  }

  public getAlarmsPark(parkNameObservable: Observable<string>, showAllObservable: Observable<boolean>, selectedTurbinesIds: string[]): Observable<Alarms> {
    return combineLatest([
      parkNameObservable,
      showAllObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([parkName, showAll]) => {
        const sort: AlarmSortInput = {createTS: Sort.Desc};
        const parameters = showAll ? { name: parkName, hours: 24, sort, selectedTurbinesIds } :
            { name: parkName, showAll: !showAll, sort, turbineIds: selectedTurbinesIds };
        return this.alarmsParkGQL.subscribe({variables: parameters}).pipe(
          map(result => Alarms.mapPark(result.data.parks[0]))
        );
      })
    );
  }

  public getAlarmsTurbine(turbineSerialObservable: Observable<number>, showAllObservable: Observable<boolean>): Observable<Alarms> {
    return combineLatest([
      turbineSerialObservable,
      showAllObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([turbineSerial, showAll]) => {
        const sort: AlarmSortInput = {createTS: Sort.Desc};
        const parameters = showAll ? { serialNav: turbineSerial, hours: 72, sort } : 
              { serialNav: turbineSerial, showAll: !showAll, sort };
        return this.alarmsTurbineGQL.subscribe({variables: parameters}).pipe(
          map(result => Alarms.mapTurbine(result.data.turbines[0]))
        );
      }
      )
    );
  }

  public getAlarmsPortfolioReport(showAllObservable: Observable<boolean>, hoursObservable: Observable<number>): Observable<Alarms> {
    return combineLatest([
      showAllObservable,
      hoursObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([showAll, hours]) => {
        return this.alarmsPortfolioReportGQL.fetch({
          variables: {
            showAll: !showAll, hours}
        }).pipe(
          map(result => Alarms.mapPortfolio(result.data.portfolios[0]))
        )
      })
    );
  }

  public getAlarmsParkReport(parkNameObservable: Observable<string>, showAllObservable: Observable<boolean>, hoursObservable: Observable<number>): Observable<Alarms> {
    return combineLatest([
      parkNameObservable,
      showAllObservable,
      hoursObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([parkName, showAll, hours]) => {
        const sort: AlarmSortInput = {createTS: Sort.Desc};
        const parameters = showAll ? { name: parkName, showAll: !showAll, hours, sort } : { name: parkName, showAll: !showAll, sort };
        return this.alarmsParkReportGQL.fetch({
          variables: parameters
        }).pipe(
          map(result => Alarms.mapPark(result.data.parks[0]))
        );
      })
    );
  }

  public getAlarmsTurbineReport(turbineSerialObservable: Observable<number>, showAllObservable: Observable<boolean>, hoursObservable: Observable<number>): Observable<Alarms> {
    return combineLatest([
      turbineSerialObservable,
      showAllObservable,
      hoursObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([turbineSerial, showAll, hours]) => {
        const sort: AlarmSortInput = {createTS: Sort.Desc};
        const parameters = showAll ? { serialNav: turbineSerial, showAll: !showAll, hours, sort } : { serialNav: turbineSerial, showAll: !showAll, sort };
        return this.alarmsTurbineReportGQL.fetch({
          variables: parameters
        }).pipe(
          map(result => Alarms.mapTurbine(result.data.turbines[0]))
        );
      }
      )
    );
  }

}
